import { WebServiceType, APIv1Type } from '@clientos/types/dist';
import getMockedNorthboundAPIs from '../../interface/getMockedNorthboundAPIs';
import { MockedCommonsNorthboundApiDependenciesType } from '../../interface/getMockedNorthboundAPIs/types';
import initializeShellInterfaceV1 from '../../interface/v1';
import initializeShellInterfaceV2, {
  ShellInterfaceV2Type
} from '../../interface/v2';
import { getServices } from '.';
import { OnboardingInputType, CommonsInitializeType } from './types';

export class APIsFactory {
  //  TODO: do a better solution to inject this dependencies
  static ConfigureWebServiceRouting(
    onboardingInput: OnboardingInputType
  ): void {
    const services = getServices();
    const { webServiceRouting } = services;

    webServiceRouting.addServices(
      onboardingInput?.stages?.map?.<WebServiceType>(
        ({ serviceId, ...stage }) => ({
          ...stage,
          id: serviceId,
          serviceType: 'web'
        })
      )
    );
  }

  /**
   * Applies mock configurations to interfaces
   * Single Responsibility: Handles only mock application logic
   */
  static async applyMocksIfEnabled(
    v1Interface: APIv1Type,
    v2Interface: ShellInterfaceV2Type,
    mockConfig?: MockedCommonsNorthboundApiDependenciesType
  ): Promise<{ v1: APIv1Type; v2: ShellInterfaceV2Type }> {
    if (!mockConfig?.enable) {
      return { v1: v1Interface, v2: v2Interface };
    }

    const mockedNorthboundAPIs = await getMockedNorthboundAPIs(mockConfig);

    return {
      v1: { ...v1Interface, ...mockedNorthboundAPIs?.v1 },
      v2: { ...v2Interface, ...mockedNorthboundAPIs?.v2 }
    };
  }

  /** Phase 7:
   * API Integration Phase - Establishing Cross-Service communication
   */
  static async createAPIs(
    commonsProps: CommonsInitializeType
  ): Promise<{ v1: APIv1Type; v2: ShellInterfaceV2Type }> {
    const { login: loginInput, mock } = commonsProps;

    // Initialize interface versions in parallel for better performance
    const [v1Interface, v2Interface] = await Promise.all([
      initializeShellInterfaceV1(commonsProps),
      initializeShellInterfaceV2(loginInput)
    ]);

    // Apply mocks if configured (Open/Closed: extensible without modification)
    const { v1, v2 } = await APIsFactory.applyMocksIfEnabled(
      v1Interface,
      v2Interface,
      mock
    );

    return { v1, v2 };
  }
}
